import { FriendSeedingScreen } from '@/features/setup/screens';
export default FriendSeedingScreen;
